module.exports = __webpack_public_path__ + "1eafeb9cb984eb04a83402fbf5b72edf.svg";